<template>
  <!-- 複数もぎり対応ダイアログ -->
  <ItemDialog
    ref="DialogSelectMultiValidFramesCount"
    imageType="alert"
  >
    <template v-slot:content-area>
      <p style="text-align: center; margin-bottom: 15px">何枚使用しますか？</p>
      <div class="div-center" v-if="isReadyToDraw">
        <div class="field w-260">
          <label>使用枚数</label>
          <div class="select-wrap">
            <select class="form-control" v-model="selectedCountOfUse" @change="setCountOfUse($event.target.value)">
              <!-- stationsをループ表示 -->
              <option class="hidden_option d-none" :value="0" selected disabled>選択してください</option>
              <option
                v-for="(count, index) in unusedSheetsCount"
                :key="index"
                :value="count"
              >
                {{ count }}枚
              </option>
            </select>
          </div>
        </div>
      </div>
    </template>

    <template v-slot:button-area>
      <ItemButton
        label="OK"
        actionType="btn-primary"
        :disabled="countOfSheets==0"
        @clicked="setStoreCountOfMultiSheets"
      />
      <!-- キャンセル -->
      <ItemButton
        v-if="!isNotTargetVersion"
        label="キャンセル"
        actionType="btn-cancel"
        @clicked="isLastRouteFromQR ? ncBackToPreviousPage(): gotoPrevious()"
      />
    </template>
  </ItemDialog>
  <!-- 複数もぎり対応ダイアログ -->
</template>

<script>
import { onMounted, computed, watchEffect, ref, SetupContext } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { lastRoute } from "@/router";
import { isAppVersionGreater } from "@/lib/compareVersion";

export default {
  name: "DialogSelectMultiValidFramesCount",
  setup(props, context) {
    const store = useStore();
    const router = useRouter();
    const isReadyToDraw = ref(false);
    const DialogSelectMultiValidFramesCount = ref(null);
    const book = computed(() => store.getters["ticketing/book"]);
    const sheet =  computed(() => store.getters["ticketing/sheet"]);
    const device = computed(() => store.getters["common/device"]);
    const appVersion = computed(() => store.getters["common/appVersion"]);
    const unusedSheets = ref([]);
    const unusedSheetsCount = ref(0);
    const countOfSheets = ref(0);
    const isModalOpen = ref(false);
    const selectedCountOfUse = ref(0);
    const isNotTargetVersion = ref(false);

    watchEffect(() => {
      if (book.value) {
        unusedSheets.value = book.value.sheets.filter(function (sheet) {
          return !sheet.is_used;
        });
        console.log("unusedSheets :>> ", unusedSheets.value);
        unusedSheetsCount.value = unusedSheets.value.length;
        isReadyToDraw.value = true;
      }
    });

    const checkVersion = () => {
      const targetVersions = {
        IOS: "2.8.8",
        ANDROID: "2.8.11",
      };

      const targetVersion = targetVersions[device.value];
      isNotTargetVersion.value = targetVersion
        ? !isAppVersionGreater(appVersion.value, targetVersion)
        : false;
    };

    const openDialog = () => {
      DialogSelectMultiValidFramesCount.value.open();
    };

    const closeDialog = () => {
      DialogSelectMultiValidFramesCount.value.close();
    };

    // ラジオボタン選択時に選択枚数を変更
    // v-modelでうまく動作しないので、@changeで変更する
    const changeRadio = (index) => {
      countOfSheets.value = index + 1;
    };

    const setStoreCountOfMultiSheets = () => {
      // 枚数をstoreへ
      store.commit("ticketing/setStoreCountOfMultiSheets", countOfSheets.value);

      const multiSheetValidIdsArray = [];
      // Add selected sheet to the array first
      multiSheetValidIdsArray.push(sheet.value.frames[0]);
      // Add other sheet to the array
      for (let i = 0; multiSheetValidIdsArray.length < countOfSheets.value && i < unusedSheets.value.length; i++) {
        if (sheet.value.id != unusedSheets.value[i].id) {
          multiSheetValidIdsArray.push(unusedSheets.value[i].frames[0]);
        }
      }

      context.emit("childMethod", multiSheetValidIdsArray);

      closeDialog();
    };

    const openModal = () => {
      isModalOpen.value = true
    };

    const setCountOfUse = (count) => {
      countOfSheets.value = count
      isModalOpen.value = false
    };

    const isLastRouteFromQR = computed(() => {
      return lastRoute.query.fromQR;
    });

    const gotoPrevious = () => {
      router.go(-1);
    };

    watchEffect(() => {
      if (appVersion.value) {
        checkVersion();
      }
    });

    return {
      isReadyToDraw,
      DialogSelectMultiValidFramesCount,
      unusedSheetsCount,
      countOfSheets,
      setStoreCountOfMultiSheets,
      changeRadio,
      openDialog,
      closeDialog,
      openModal,
      setCountOfUse,
      isModalOpen,
      gotoPrevious,
      selectedCountOfUse,
      isLastRouteFromQR,
      isNotTargetVersion,
    };
  },
};
</script>

<style lang="scss" scoped>
.imi-input{
    width: 100%;
    max-width: 260PX;
    background: white;
    border: 1px solid #c8c8c8;
    border-radius: 5px;
    font-size: 20px;
    padding: 5px;

    label{
      float: left;
      color: grey;      
      font-size: 14px;
      line-height: 30px;
    }
    span{
      font-size: 14px;
      line-height: 30px;

      strong{
        font-size: 20px;
      }
    }

    img{
      height: 10px;
      margin: 10px 5px;
      /* line-height: 30px; */
      float: right;
      display: block;
    }
    :hover{
      background: #f9f9f9;
    }
}
.imi-input:hover{
  background: #f9f9f9;
}
.modal{
  position: absolute;
  margin-top: 5px;
  width: 75%;
  max-width: 245PX;
  background: white;
  border: 1px solid #c8c8c8;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  z-index: 101;

  button{
  font-size: 20px;
  background: white;
  border: none;
  color: #5e5e5e;
  border-bottom: 1px solid #c8c8c8;
  padding: 5px;
  border-radius: 5px;
  }
}

.d-none {
  display: none;
}

.field {
  position: relative;
  margin: 0 0 0 0;
}

.w-260 {
  width: 260px;
}

.field label {
  position: absolute;
  width: 70px;
  z-index: 100;
  top: 0;
  margin-top: 15px;
  margin-left: 7px;
  font-size: 14px;
  color: #888888;
}

.button-swap {
  display: block;
  padding: 1em 2em 1em 1em;
  width: 40px;
  height: 100px;
  text-align: center;
  background: #f0f0f0;
  background-image: url("~@/assets/img/icon/svg/icon-swap.svg");
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #c8c8c8;
  border-radius: 6px;
}

/* セレクトボックス */
select {
  -webkit-appearance: none;
  width: 100%;
  height: 44px;
  margin-bottom: 0;
  border: 1px solid #c8c8c8;
  border-radius: 6px;
  background-color: #ffffff;
  outline: none;
  padding: 11px 10px 12px 105px;
  font-size: 15px;
  line-height: 14px;
  font-weight: bold;
  color: #000000;
}

.select-wrap {
  width: 100%;
  position: relative;
  display: inline-block;
  border-radius: 6px;
}

.select-wrap::after {
  content: "";
  width: 10px;
  height: 10px;
  border: 0px;
  border-bottom: solid 3px #231f20;
  border-right: solid 3px #231f20;
  -ms-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  top: 15px;
  right: 3vw;
  margin-top: -4px;
}

.div-center {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
</style>
